import { render } from "../views/typing_indicator.html?vue&type=template&id=6bf45ea9&ts=true&external"
import script from "../scripts/typing_indicator.ts?vue&type=script&lang=ts&external"
export * from "../scripts/typing_indicator.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/typing_indicator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6bf45ea9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6bf45ea9', __exports__)) {
    api.reload('6bf45ea9', __exports__)
  }
  
  module.hot.accept("../views/typing_indicator.html?vue&type=template&id=6bf45ea9&ts=true&external", () => {
    api.rerender('6bf45ea9', render)
  })

}


export default __exports__